import { AfterViewInit, Component, EventEmitter, NgZone, Output, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { DataService } from '../core/data.service';
import { RecurrencyStatus } from '../shared/enums';

@Component({
  selector: 'app-recurrent-tour-list',
  template: `
    <!--<div class="list-controls">
      <div class="form-check form-check-inline">
        <label class="form-check-label">
          <input class="form-check-input" type="radio" name="source" value="templates"> Templates
        </label>
      </div>
      <div class="form-check form-check-inline">
        <label class="form-check-label">
          <input class="form-check-input" type="radio" name="source" value="tours"> Tours
        </label>
      </div>
    </div>-->
    <dx-data-grid [dataSource]="tourTemplates" keyExpr="id" >
      <dxi-column dataField="templateName" caption="Template Name"></dxi-column>
      <dxi-column dataField="templateDescription" caption="Description"></dxi-column>
      <dxi-column dataField="vehicle.licensePlate" caption="Vehicle"></dxi-column>
      <dxi-column dataField="recurrencyPattern.status" caption="Status" filterValue="Active"
        alignment="left" [calculateCellValue]="calculateStatusCellValue" [allowFiltering]="true">
        <dxo-lookup [dataSource]="recurrencyStatus" valueExpr="text" displayExpr="text">
        </dxo-lookup>
      </dxi-column>
    </dx-data-grid>
  `,
  styles: [`
    :host {
      height: 100%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column;
      flex-direction: column;
      padding: 1.5rem;
    }
  `]
})
export class RecurrentTourListComponent implements AfterViewInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @Output() tourTemplateSelected = new EventEmitter();
  tourTemplates = [];
  tours = [];
  recurrencyStatus = Object.keys(RecurrencyStatus).map(s => ({ text: s, value: RecurrencyStatus[s] })).filter(d => typeof d.value === 'number');

  constructor(
    private dataService: DataService,
    private ngZone: NgZone
  ) {}

  ngAfterViewInit() {
    this.dataGrid.instance.option({
      columnAutoWidth: true,
      filterRow: { visible: true },
      height: '100%',
      hoverStateEnabled: true,
      onSelectionChanged: this.onGridSelectionChanged,
      selection: { mode: 'single' },
      showBorders: true
    });
    this.refresh();
  }

  calculateStatusCellValue(rowData) {
    return RecurrencyStatus[rowData.recurrencyPattern.status];
  }

  onGridSelectionChanged = (e) => {
    this.ngZone.run(() => {
      let tourTemplate = e.selectedRowsData[0];
      if (tourTemplate) {
        this.dataService.getTourTemplate(tourTemplate.id).then(tourTemplate => {
          this.tourTemplateSelected.emit(tourTemplate);
        });
      } else {
        this.tourTemplateSelected.emit(null);
      }
    });
  }

  refresh() {
    return this.dataService.getTourTemplates().then(tourTemplates => {
      this.tourTemplates = tourTemplates;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/recurrence/recurrent-tour-list.component.ts